import React, { Component } from 'react';
import Dialog from "../dialog/dialog";
import ScrollBox from '../scroll/scrollBox2.0';
import Button from '../button/button'
// import { zIndex } from 'material-ui/styles';

class PreviewImage extends Component {
    constructor() {
        super();
        this.state = {
            open: false
        };
    };
    //图片点击放大方法
    clickImg = () => {
        this.setState({
            open: true
        })
    }
    //关闭dialog
    handleClose = () => {
        this.setState({
            open: false
        })
    }
    componentDidMount = () => {
        if (this.props.open == true) {
            this.setState({
                open: true,
            });
        }
    };



    render() {
        const { ...props } = this.props;
        // const zIndex = props.zIndex?props.zIndex:"";
        const contentStyle = { minWidth: "90rem", maxWidth: '120rem', height: "50rem" };
        const bodyStyle = { width: '100%' };
        const actions = [
            <Button scenesType="back" btnText="返回" handleBtn={this.handleClose} />
        ];

        return (
            <div>
                <img src={props.src} onClick={this.clickImg}
                    style={{ width: props.width || "4rem", height: props.height || "4rem" }} />

                <Dialog
                    open={this.state.open}
                    handleClose={this.handleClose}
                    contentStyle={contentStyle}
                    bodyStyle={bodyStyle}
                    actions={actions}
                    // zIndex={zIndex}
                >
                    <ScrollBox
                        maxHeight="40rem"
                        scrollBarColor="#cccccc"
                        autohide={true}
                    >
                        <div>
                            <img style={{ width: "100%" }} src={props.src} />

                        </div>
                    </ScrollBox>
                </Dialog>
            </div>
        );
    };
}


export default PreviewImage;